import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>ENERGY FIELD MODEL
                                            </div>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/momentum_img.png')}
                                                    alt=""/>
                                            </div>

                                            <div className="border_subtitle">Key to the Energy field model</div>
                                            <p>The Ideal situation is when moving from the start of a task to
                                                completion you achieve a state of
                                                <span className="subtiltereg">‘Flow’</span>, whereby you’re
                                                balancing the momentum/movement. You achieve this by countering
                                                the
                                                negative restraining forces with the positive driving forces.
                                            </p>
                                            <div className="border_subtitle">Driving Forces*</div>
                                            <ul className="greenbullet-list">
                                                <li><span
                                                    className="subtiltereg">Motivation</span> (Intrinsically +
                                                    Extrinsically motivating factors).
                                                </li>
                                                <li><span className="subtiltereg">Goal-setting</span> (SMART
                                                    objectives) – <span className="subtiltereg">see ‘How to formulate action plans’ tool.</span>
                                                </li>
                                                <li><span
                                                    className="subtiltereg">Positive cognition</span> (Positive
                                                    thinking; Constructive thoughts; Building positive
                                                    mental schema).
                                                </li>
                                                <li><span
                                                    className="subtiltereg">Positive emotional state</span> (for
                                                    example, positive emotions, happiness, humour,
                                                    optimism, etc.).
                                                </li>
                                                <li><span className="subtiltereg">Coping skill</span> (for
                                                    example, access to, and/or creation of, resources;
                                                    Emotional/Instrumental/
                                                    Informational Support).
                                                </li>
                                                <li><span className="subtiltereg">Feedback</span> (continuous
                                                    feedback from others leading to corrective actions).
                                                </li>
                                            </ul>
                                            <div className="border_subtitle">Restraining Forces*
                                            </div>
                                            <ul className="greenbullet-list">
                                                <li><span
                                                    className="subtiltereg">Negative cognition</span> (Negative
                                                    thinking; Destructive thoughts; Breaking negative mental
                                                    schema).
                                                </li>
                                                <li><span
                                                    className="subtiltereg">Workplace/personal stressors </span>(for
                                                    example, workload, role conflict/role ambiguity, lack of
                                                    support, interpersonal conflict, work-life imbalance, etc.).
                                                </li>
                                                <li><span
                                                    className="subtiltereg">Negative emotional state</span> (for
                                                    example, negative emotions, pessimism, etc.).
                                                </li>
                                                <li><span className="subtiltereg">Boredom</span> (in a sense,
                                                    the opposite of ‘flow’).
                                                </li>
                                            </ul>
                                            <p className="subText">*Note: This is not an exhaustive list of
                                                possible ‘forces!’</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}